export default "__VITE_ASSET__CSDRoSyf__"